import {
	AUTH_ACCESS_TOKEN_KEY,
	AUTH_REFRESH_TOKEN_KEY,
	IS_AUTH_KEY,
	authAccessTokenEntity,
	authRefreshTokenEntity,
	isAuthEntity,
	authAccessTokenSessionEntity,
	authRefreshTokenSessionEntity
} from './storage';
import { IAuthEntity } from './interface';
import store from '@/store';
import { AUTH_MODULE_NAME } from "@/store/modules/auth";

export const authEntity: IAuthEntity = {

	get isAuth(): boolean {
		return !!(this.accessToken && this.refreshToken);
	},

	get accessToken(): string {
		return authAccessTokenEntity[AUTH_ACCESS_TOKEN_KEY] || '';
	},

	set accessToken(v: string) {
		authAccessTokenEntity[AUTH_ACCESS_TOKEN_KEY] = v;
	},

	get refreshToken(): string {
		return authRefreshTokenEntity[AUTH_REFRESH_TOKEN_KEY] || '';
	},

	set refreshToken(v: string) {
		authRefreshTokenEntity[AUTH_REFRESH_TOKEN_KEY] = v;

		this.isAuthIndicator = !!v;
	},

	get accessTokenInSession(): string {
		return authAccessTokenSessionEntity[AUTH_ACCESS_TOKEN_KEY] || '';
	},

	set accessTokenInSession(v: string) {
		authAccessTokenSessionEntity[AUTH_ACCESS_TOKEN_KEY] = v;
	},

	get refreshTokenInSession(): string {
		return authRefreshTokenSessionEntity[AUTH_REFRESH_TOKEN_KEY] || '';
	},

	set refreshTokenInSession(v: string) {
		authRefreshTokenSessionEntity[AUTH_REFRESH_TOKEN_KEY] = v;
	},

	get isAuthIndicator(): boolean {
		return isAuthEntity[IS_AUTH_KEY] !== '0';
	},

	set isAuthIndicator(v: boolean) {
		isAuthEntity[IS_AUTH_KEY] = v ? '1' : '0';
	},

	get authedState(): boolean {
		return store.getters[`${AUTH_MODULE_NAME}/isAuth`];
	},

	set authedState(v: boolean) {
		store.commit(`${AUTH_MODULE_NAME}/setAuth`, v);
	},

	get customerSessionExpiredState(): boolean {
		return store.getters[`${AUTH_MODULE_NAME}/customerSessionExpired`];
	},

	set customerSessionExpiredState(value: boolean) {
		store.commit(`${AUTH_MODULE_NAME}/setCustomerSessionExpired`, value);
	}

};